import React, { useEffect, useState } from 'react'
import { Modal } from '../../components/others/Modal'
import { TableActions } from '../../components/others/TableActions'
import { PrimaryButton } from '../../components/others/ButtonPrimary'
import { useModal } from '../../hooks'
import LavorisService from '../../services/LavorisService'

type MultiplePracticesForm = {
    rowData: any,
    show: boolean,
    refreshTable: Function,
    onClose: Function,
    modalTitle: string,
    urlTittle: string,
    download: Function,
    appId?: string,
}

const MultiplePracticesModal = ({ rowData, show, onClose, modalTitle, urlTittle, download }: MultiplePracticesForm) => {
    const practices = rowData?.metadata?.simplified.filter((practice: any) => practice.form).map((practice: any) => practice);
    const [selectedPractices, setSelectedPractices] = useState<any[]>(practices)


    if (!rowData) return null
    return (
        <>
            <Modal
                show={show}
                onClose={() => onClose?.()}
                modalTitle={modalTitle}
                urlTittle={urlTittle}
                titleStyle="text-2xl text-red-500 font-bold my-4"
                modalContainerStyle="max-w-lg"
            >
                <ul className='flex flex-col gap-2 p-0 m-0 align-middle list-disc'>
                    {selectedPractices?.map((p: any, i: any) => (
                        <li key={i} className='flex gap-3 w-[300px] justify-between align-middle border-b-2  border-red-600 mb-2'>
                            <p className='w-[300px] self-center '>{p.name} </p>
                            <div className='flex gap-3 my-2'>
                                <div className='self-center '>
                                    <TableActions
                                        type="Download"
                                        title="PDF individual"
                                        onClick={() => download?.(p.pdfUrl)}
                                    />
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </Modal>
        </>
    )
}

export default MultiplePracticesModal